export const AMAZON_URL = "https://www.amazon.com/dp/B0HKFF979L";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
